import MobileDetect from 'mobile-detect';

export const getWindowSize = userAgent => {
  const md = new MobileDetect(userAgent);

  if (md.phone()) {
    return {
      fallbackWidth: 360,
      fallbackHeight: 640,
    };
  }

  if (md.tablet() ) {
    return {
      fallbackWidth: 768,
      fallbackHeight: 1024,
    };
  }

  return {
    fallbackWidth: 1024,
    fallbackHeight: 700,
  };
};
